window.onload = function () {
    if(document.querySelector('.footer-subs-form') !== null){
        var x = getCookie('newsletter');
        var x1 = getCookie('newsletter_closed');
        if (x1 != 'true' && x != 'true' && window.location.pathname != '/challenge') {
            setTimeout(()=>{
                openSubscribePopUp();
            }, window.show_popup);
            const newsLetter = document.querySelector('.footer-subs-form');
            if(window.location.search == '?customer_posted=true' || window.location.search == '?form_type=customer'){
                document.querySelector('#subscribe-popup-form').classList.add('d-none');
                document.querySelector('#subscribe-popup-thanks').classList.remove('d-none');
                setCookie('newsletter','true',30);
            }else{
                document.querySelector('#close-subscribe-popup').addEventListener('click', function () {
                    setCookie('newsletter_closed','true',1);
                })
                newsLetter.querySelector('#subscribe-popup-btn-send').addEventListener('click', function (e) {
                    e.stopImmediatePropagation();
                    let validation = true;
                    let field = newsLetter.querySelector('#subscribe-popup-email-input');
                    let fieldValue = field.value.trim();
                    if (fieldValue === '') {
                        validation = false;
                        alert("Field can't be blank");
                    } else {
                        console.log('ckeck email', field.value)
                        if (validateEmail(field.value) != true) {
                            validation = false;
                            alert("Invalid value");
                        } else {
                            console.log('input - valid')
                            newsLetter.submit();
                        }
                    }
                })
            }
        }
    }
}

function validateEmail(email){
    let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email.match(email_string)){
        return true;
    }else {
        return false;
    }

}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
